import {useMemo, type PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useVersion} from '../context';
import styles from './content.module.css';

type Props = PropsWithChildren;

export function MediaUserOnlyInfoContent({children}: Props) {
  const version = useVersion();
  const is2015 = useMemo(() => version === '2015', [version]);
  return (
    <p
      className={clsx(
        is2015 ? styles.content2015 : styles.content,
        isContainerQueryAvailable()
          ? is2015
            ? styles.content2015CQ
            : styles.contentCQ
          : is2015
            ? styles.content2015Fallback
            : styles.contentFallback,
      )}
    >
      {children}
    </p>
  );
}
